import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { Modal } from 'antd';
import { useClassGameActivity, useOneGameModal } from 'store/one_game/selectors';
import { useSocket } from 'store/chat/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { useCurrentClass } from 'store/classes/selectors';
import { useDispatch } from 'react-redux';
import { handleCreateGameSession, handleUpdateCurrentGameSessionStatus } from 'store/game_session/thunks';
import { get  } from 'lodash'
import { useCurrentGameSession } from 'store/game_session/selectors';
import config from 'config';
import queryString from 'query-string';
import { handleLearningModuleCount } from 'store/bingo/thunks';
import { useLocation } from 'react-router-dom';
import SentryWrap from 'components/Sentry';
import { logToSentry } from 'utils/networkErrorUtils';

const FullWindowModal = ({iframeUrl,open1game}) => {
  const { closeOnegamerModal,closeCurrentGameSession } = useOneGameModal()
  const { socketConnection , reCreateSocket } = useSocket()
  const { fetchClassGameActivity } = useClassGameActivity()
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const dispatch = useDispatch()
  const location = useLocation();
  const { currentGameSession } = useCurrentGameSession();
  const [search, setSearch] = React.useState({});
  const sessionIdRef = useRef(null);
  const wasOneGameOpenRef = useRef(false);
  const sessionEndedRef = useRef(false);
  const isStudent = useMemo(() => get(currentUser, 'role') === 'student', [currentUser]);

  useEffect(() => {
    const sid = get(currentGameSession, 'session_id');
    if (sid) sessionIdRef.current = sid;
  }, [currentGameSession]);

  const endGameSessionIfNeeded = useCallback(() => {
    if (isStudent) return;
    if (sessionEndedRef.current) return;
    const sid = sessionIdRef.current;
    if (!sid) return;
    sessionEndedRef.current = true;
    dispatch(handleUpdateCurrentGameSessionStatus(sid, 'ended'));
  }, [dispatch]);

  useEffect(() => {
    if (open1game) {
      wasOneGameOpenRef.current = true;
      sessionEndedRef.current = false;
    } else if (wasOneGameOpenRef.current) {
      wasOneGameOpenRef.current = false;
      endGameSessionIfNeeded();
    }
  }, [open1game, endGameSessionIfNeeded]);

  useEffect(() => {
    return () => {
      if (wasOneGameOpenRef.current) endGameSessionIfNeeded();
    };
  }, [endGameSessionIfNeeded]);

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    setSearch(parsed);
  }, [currentGameSession, location]);

  const notifyStudents = (data) => {
    if (socketConnection) {
        try {
            if (socketConnection.readyState == 3) {
                reCreateSocket()
                setTimeout(() => {
                    socketConnection.send(JSON.stringify(data))
                }, 2000)
            } else {
                socketConnection.send(JSON.stringify(data))
            }
        } catch (error) {
            console.log(error, "error")
        }
    }
  }
  // TODO:  need to check
const sendNotifications = async (notificationData) => {
  try {
      const messageCreate = {
          ...notificationData,
          senderId: get(currentUser, 'id', ''),
          receiverId: '',
          classId: get(currentClass, 'id', ''),
          code: 'system_notification'
      }
      notifyStudents(messageCreate)
  } catch (error) {
      console.log(error, "error")
  }
}

const getChapter = () => {
  if (location.pathname.includes('informateBook')) {
    return '41'
  } else if (location.pathname.includes('balconCulturalBook')) {
    return '33'
  } else if (location.pathname.includes('ComunidadBook')) {
    return '43'
  } else if (location.pathname.includes('ConectandomeBook')) {
    return '49'
  } else if (location.pathname.includes('stories')) {
    return '255';
  }
  return search.chapter || search.id;
}

useEffect(() => {
  const handleEvent = (event) => {
    if (event.data) {
      switch (event.data.action) {
        case 'close_one_game':
          ongame_close();
          setTimeout(fetchClassGameActivity,3000)
          const chapter = getChapter();
          if (chapter) {
            dispatch(handleLearningModuleCount({
              chapter: chapter,
              userId: currentUser.id,
              pageId: search.page || search.id,
            }));
          }
          break;
        case 'closeIframe':
          closeCurrentGameSession();
          break;
        case 'setStudentSessionId':
          const { studentSessionId } = event.data;
          sessionStorage.setItem('studentSessionId', studentSessionId);
          break;
        case 'refresh':
          window.location.reload();
          break;
        case 'stop_iframe_scroller':
        case 'release_iframe_scroller':
          const iframes = document.getElementsByClassName("iframeWrapMain");
          for (let i = 0; i < iframes.length; i++) {
            iframes[i].style.overflow = event.data.action === 'stop_iframe_scroller' ? 'hidden' : 'auto';
          }
          break;
        case 'game_start_notify':
          const { session_info } = event.data;
          if (session_info) {
            const game_data = session_info.game;
            dispatch(handleCreateGameSession(session_info.id, currentUser.id, currentClass.id, game_data));
            let notifydata = {
              userId: currentUser.id,
              classId: currentClass.id,
              game_data: game_data,
              session_id: session_info.id,
              session_code: session_info.pin_code,
              code: 'play_game_notification'
            };
            const notificationData = {
              classId: currentClass.id.toString(),
              displayName: `${game_data?.display_name.slice(0, 20)}...`,
              userId: currentUser.id.toString(),
              modified: new Date(),
              data: notifydata,
              message: "Game is started by your teacher, please join.",
              createdBy: currentClass.id.toString(),
              type: 'play_game_notification',
              seen: true
            };
            sendNotifications(notificationData);
            notifyStudents(notifydata);
          }
          break;
        default:
          break;
      }
    }
  };

  window.addEventListener('message', handleEvent);

  return () => {
    window.removeEventListener('message', handleEvent);
  };
}, [currentGameSession, search]); 

  useEffect(() => {
    if (open1game) {
      setTimeout(() =>{
        document.body.style.cssText = 'overflow: hidden';
      },1000)
     
    } else {
      setTimeout(() =>{
        document.body.style.cssText = 'overflow: scroll';
      },1000)
    }
    return ()=>{
      setTimeout(() =>{
        document.body.style.cssText = 'overflow: scroll';
      },1000)
    }
  }, [open1game])

  useEffect(() => {
    if (open1game && iframeUrl) {
      const checkUrlAccessibility = async () => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);
        
        try {
          const url = new URL(iframeUrl);
          //only domain
          const domain = url.origin;
          console.log("domain", domain)
          // const response = await fetch(`${domain}`, {
          //   method: 'GET',
          //   signal: controller.signal
          // });
          
          // clearTimeout(timeoutId);
          
          // if (!response.ok && response.status >= 400) {
          //   logToSentry({
          //     message: 'Failed to access game',
          //     error: new Error('Failed to access game'),
          //     module: 'ONE_GAME',
          //     operation: 'ACCESS_GAME_HEAD',
          //   });
          //   console.log("response-1game", response)
          //   Modal.error({
          //     title: 'Unable to Access Game',
          //     content: 'We\'re unable to access the game at this time. Please contact your system administrator for assistance.',
          //     onOk: () => closeOnegamerModal(),
          //     zIndex: 100000,
          //   });
          // }
        } catch (error) {
          clearTimeout(timeoutId);
          console.log("1game load error", error)
          logToSentry({
            message: 'Failed to access game',
            error: error,
            module: 'ONE_GAME',
            operation: 'ACCESS_GAME',
            tags: {
              errorType: 'ACCESS_GAME',
              module: 'ONE_GAME',
              operation: 'ACCESS_GAME',
            },
            extra: {
              url: iframeUrl,
            },
            level: 'error',
            type: 'exception',
          })
          if (error.name === 'AbortError') {
            Modal.error({
              title: 'Connection Timeout',
              content: 'The game is taking too long to load. This may be due to network issues or the game being temporarily unavailable. Please contact your system administrator for assistance.',
              onOk: () => closeOnegamerModal(),
              zIndex: 100000,
            });
          } else if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
            Modal.error({
              title: 'Game Not Accessible',
              content: 'We\'re unable to connect to the game. This may be due to network restrictions or the game being blocked. Please contact your system administrator for assistance.',
              onOk: () => closeOnegamerModal(),
              zIndex: 100000,
            });
          }
        }
      };

      checkUrlAccessibility();
    }
  }, [open1game, iframeUrl, closeOnegamerModal]);

const ongame_close = useCallback(closeOnegamerModal,[currentGameSession,open1game])
  return (
<SentryWrap>
  <Modal
  open={open1game}
  width="100%"
  style={{ top: 0 }}
  title={null}
  styles={{ body: { height: '100vh !important', padding: 0 } }}
  footer={null}
  destroyOnHidden
  onCancel={ongame_close}
  closable={config.is_local}
  className='one_game_open'
  wrapClassName='iframeWrapMain iframe-1game-1study'
>
  <iframe
    src={iframeUrl}
    title="Your Iframe Title"
    width="100%"
    height="100%"
    allow="microphone; autoplay; clipboard-write; clipboard-read"
    style={{ border: 0, height: '100% !important', position: 'fixed', top: 0, left: 0 }}
  ></iframe>
  </Modal>
</SentryWrap>
  );
};

export default FullWindowModal; 
